import { InjectionToken } from '@angular/core';
export interface RibbonTranslations {
  ariaLabel: string;
}

export const RIBBON_TRANSLATIONS = new InjectionToken<RibbonTranslations>('RIBBON_TRANSLATIONS');
